/** Mirror of zeecore keyfuels diesel price limits (client-side checks). */

export const KEYFUELS_DIESEL_PRICE_MAX_PDF_BYTES = 10 * 1024 * 1024; // 10 MiB
export const KEYFUELS_DIESEL_PRICE_MAX_PPL = 1000;
